<template>
    <div v-if="loading">
        <vx-card>
            <h3> Loading... Please wait...</h3>
        </vx-card>
    </div>
    <vx-card v-else>
        <div class="vx-row">
            <div class="vx-col w-full mb-3">
                <vs-input
                    class="w-full" 
                    label="Entity Name" 
                    placeholder="Enter name of the entity" 
                    v-model="entity.name"
                    :warning="api_errors.name"
                    :warning-text="api_errors.name?api_errors.name[0]:null"
                />
            </div>
            <div class="vx-col w-full mb-3">
                <InputSelect
                    :model.sync="entity.entity_type"
                    label="Select Entity Type"
                    placeholder="Select from List"
                    :options="entity_type_options"
                    :warning="api_errors.entity_type"
                    :warning_text="api_errors.entity_type ? api_errors.entity_type.join(',') : null"
                />
            </div>
            <div class="vx-col w-full mt-3 text-center">
                <vs-button 
                    color="primary" 
                    type="filled" 
                    @click.prevent="save"
                    :disabled="submit_disabled"
                >Save</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>

import {Request} from "../../utils/requests"

export default {
    data() {
        return {
            loading: true,
            entity_type_options: [
                {label: 'Individual', value: 'i'},
                {label: 'Company', value: 'c'},
            ],

            entity: {
                name: null,
                entity_type: null,
            },
            entity_id: this.$route.params.entity_id,
            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        '$route.params.entity_id'(newV) {
            this.init()
        }
    },
    methods: {
        init() {
            this.entity_id = this.$route.params.entity_id
            if(this.entity_id){
                this.loadData()
            } else { 
                this.loading = false
                this.entity = {
                    name: null,
                    open_quantity: null,
                }
            }
        },
        loadData() {
            this.loading = true
            this.$vs.loading()

            let url = this.$store.state.apiendpoints.entity + this.entity_id + "/"

            Request(this, 'GET', url).then(
                (res) => { 
                    this.entity = res
                    this.loading = false
                    this.$vs.loading.close()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured while loading data. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                    this.$router.push("/")
                }
            )
        },
        save(){
            let $this = this
            let url = $this.$store.state.apiendpoints.entity, request_method = 'POST'

            if(this.entity_id){
                url += this.entity_id + "/"
                request_method = 'PUT'
            }

            let data = {...this.entity}

            this.submit_disabled = true

            Request($this, request_method, url, null, data).then( 
                (res) => {
                    $this.$vs.notify({
                        time: 2500,
                        title: 'Saved',
                        text: 'Saved Successfully',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        color: 'success'
                    })
                    this.submit_disabled = false
                    $this.$router.push({name: 'entity-list'})
                },
                (err) => {
                    if(err.error) {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please check all fields and Try Again.',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.api_errors = err.error
                    } else {
                        $this.$vs.notify({
                            time: 2500,
                            title: 'Unknown Error',
                            text: 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                    this.submit_disabled = false
                }
            )
        }
    }
}
</script>